import styled from 'react-emotion'

import Colors from '../../../themes/Colors'
import { mobile } from '../../../utils/mixins'
import { Typo24WhiteTwoDI } from '../../../themes/Fonts/Din2014'

import ApplyButton from '../ButtonComponent'

export const ButtonWrapper = styled('div')`
  @media (max-width: 767px) {
    margin-top: 1.429em;
    margin-bottom: 80px;
  }
  ${mobile} {
    margin: 0;
    margin-top: 20px;
  }
`

export const BookButton = styled(ApplyButton)`
  width: 100%;
  height: 52px;
  display: block;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  ${mobile} {
    width: 40%;
    height: 40px;
    margin-left: auto;
    margin-right: auto;
    text-transform: uppercase;
    padding: 10px 10px;
    background: ${Colors.darkSaturatedOrange};
  }
`

export const ScrollButtonWrapper = styled('div')`
  display: none;
  position: fixed;
  bottom: 0%;
  left: 0%;
  z-index: 1;
  width: 100vw;
  ${mobile} {
    margin: 0;
    margin-top: 20px;
    display: ${props => (props.isVisible ? 'block' : 'none')};
  }
`

export const ScrollBookButton = styled(ApplyButton)`
  width: 100vw;
  height: 52px;
  display: block;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  ${mobile} {
    margin-left: auto;
    margin-right: auto;
    padding: 10px 10px;
    background: ${Colors.darkSaturatedOrange};
  }
`

export const ScrollButtonSupportText = styled(Typo24WhiteTwoDI)`
  display: block;
  opacity: 0.8;
  font-size: 13px;
  text-align: center;
  position: relative;
  line-height: unset;
  padding-left: 0;
  padding-right: 0;
`

export const ButtonSupportText = styled(Typo24WhiteTwoDI)`
  display: block;
  opacity: 0.8;
  font-size: 13px;
  text-align: center;
  position: relative;
  line-height: unset;
  padding-left: 0;
  padding-right: 0;
  padding-top: 10px;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/MobileBookNowButton/styledComponents.js